import { render, staticRenderFns } from "./MajoritiesInfo.vue?vue&type=template&id=285bac36&"
import script from "./MajoritiesInfo.vue?vue&type=script&lang=js&"
export * from "./MajoritiesInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports